import { render, staticRenderFns } from "./WeekRow.vue?vue&type=template&id=4b791d7f"
import script from "./WeekRow.vue?vue&type=script&lang=ts"
export * from "./WeekRow.vue?vue&type=script&lang=ts"
import style0 from "./WeekRow.vue?vue&type=style&index=0&id=4b791d7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports